// extracted by mini-css-extract-plugin
module.exports = {"container":"_82e3db2ea0--container--KOYjJ","fade":"_82e3db2ea0--fade--zRBkk","chat-icon":"_82e3db2ea0--chat-icon--DA128","content":"_82e3db2ea0--content--Q4oH1"};